import { useIsFetching, useIsMutating } from "@tanstack/react-query";
import { useEffect, useState, useRef } from "react";

export function GlobalLoader() {
    const isFetching = useIsFetching();
    const isMutating = useIsMutating();
    const [isVisible, setIsVisible] = useState(false);
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    const isLoading = isFetching > 0 || isMutating > 0;

    // استفاده از window.location به جای useLocation
    const isAdmin = typeof window !== 'undefined' && window.location.pathname.startsWith('/app/admin');

    useEffect(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }

        if (isLoading) {
            setIsVisible(true);
        } else {
            timeoutRef.current = setTimeout(() => {
                setIsVisible(false);
            }, 300);
        }

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [isLoading]);

    if (!isVisible) return null;

    return isAdmin ? <AdminLoadingSpinner /> : <DefaultLoadingSpinner />;
}

// ============== لودینگ پیش‌فرض (موبایل و غیرادمین) ==============
const DefaultLoadingSpinner = () => {
    return (
        <div className="fixed inset-0 z-[1000] w-full max-w-[450px] 3xl:max-w-[504px] h-dvh mx-auto">
            <div className="absolute inset-0 transition-opacity backdrop-blur-sm duration-300 w-full h-full" />
            <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[1001] flex gap-2 items-end h-20">
                <div className="w-4 rounded-full bg-brand-600 animate-pulse1"></div>
                <div className="w-4 rounded-full bg-brand-600 animate-pulse2"></div>
                <div className="w-4 rounded-full bg-brand-600 animate-pulse3"></div>
            </div>
        </div>
    );
};

// ============== لودینگ دسکتاپ (ادمین) ==============
const AdminLoadingSpinner = () => {
    return (
        <div className="fixed inset-0 z-[1000] bg-white/80 backdrop-blur-sm flex items-center justify-center">
            <div className="flex flex-col items-center gap-6">
                {/* اسپینر دایره‌ای بزرگتر */}
                <div className="relative w-20 h-20">
                    <div className="absolute inset-0 border-4 border-brand-100 rounded-full"></div>
                    <div className="absolute inset-0 border-4 border-t-brand-600 rounded-full animate-spin"></div>
                    <div className="absolute inset-[6px] border-4 border-brand-50 rounded-full"></div>
                    <div className="absolute inset-[6px] border-4 border-t-brand-400 rounded-full animate-spin animation-delay-200"></div>
                </div>

                {/* متن */}
                <div className="flex flex-col items-center gap-2">
                    <p className="text-brand-600 font-medium text-lg animate-pulse">
                        در حال بارگذاری...
                    </p>
                    <div className="flex gap-1">
                        <span className="w-2 h-2 bg-brand-400 rounded-full animate-bounce animation-delay-0"></span>
                        <span className="w-2 h-2 bg-brand-500 rounded-full animate-bounce animation-delay-150"></span>
                        <span className="w-2 h-2 bg-brand-600 rounded-full animate-bounce animation-delay-300"></span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GlobalLoader;